// Display formatting only — no pricing arithmetic lives here.

export function money(n: number | string | null | undefined): string {
  if (n == null || n === '') return '—';
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return '$' + Math.round(v).toLocaleString('en-US');
}

export function perSf(n: number | string | null | undefined): string {
  if (n == null || n === '') return '—';
  const v = Number(n);
  return Number.isFinite(v) ? `$${v.toFixed(2)}` : '—';
}

export function pct(n: number | string | null | undefined, digits = 0): string {
  if (n == null || n === '') return '—';
  const v = Number(n);
  return Number.isFinite(v) ? `${(v * 100).toFixed(digits)}%` : '—';
}

export function num(n: number | string | null | undefined): string {
  if (n == null || n === '') return '—';
  const v = Number(n);
  return Number.isFinite(v) ? v.toLocaleString('en-US') : '—';
}

export function shortDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/** Parse a typed number; blank is null, anything unreadable is null. */
export function parseNumber(v: string): number | null {
  const t = v.replace(/[$,\s]/g, '');
  if (t === '') return null;
  const n = Number(t);
  return Number.isFinite(n) && n >= 0 ? n : null;
}
